import {
  Component,
  computed,
  forwardRef,
  inject,
  OnInit,
  signal,
  viewChild
} from '@angular/core';
import { BaseLeftMenuItemComponent } from '../base-left-menu-item/base-left-menu-item.component';
import { MenuWithSubMenu } from '../../types/left-menu.types';
import { smoothShowHideHeight, smoothShowHideWidth } from '../../../../../shared/animations/smoothShowHideAnimations';
import {
  CollapsedSubmenuLeftMenuItemListComponent
} from './collapsed-submenu-left-menu-item-list/collapsed-submenu-left-menu-item-list.component';
import { SubmenuLeftMenuItemService } from "./services/submenu-left-menu-item.service";
import { LeftMenuListComponent } from "../../left-menu-list/left-menu-list.component";

@Component({
  selector: 'app-submenu-left-menu-item',
  standalone: true,
  imports: [
    forwardRef(() => LeftMenuListComponent),
    CollapsedSubmenuLeftMenuItemListComponent
  ],
  templateUrl: './submenu-left-menu-item.component.html',
  styleUrls: [
    './submenu-left-menu-item.component.scss',
    '../base-left-menu-item/base-left-menu-item.component.scss'
  ],
  animations: [
    smoothShowHideHeight,
    smoothShowHideWidth
  ]
})
export class SubmenuLeftMenuItemComponent extends BaseLeftMenuItemComponent implements OnInit {
  collapsedSubmenuListElement = viewChild(CollapsedSubmenuLeftMenuItemListComponent);

  private submenuLeftMenuItemService: SubmenuLeftMenuItemService = inject(SubmenuLeftMenuItemService);

  public isSubmenuOpen = signal<boolean>(false);
  private submenusUrls = signal<Array<string>>([]);
  public menuWithSubMenu = computed(() => this.menu() as MenuWithSubMenu);

  public get isSubmenuActive(): boolean {
    if (this.isSubmenuOpen()) { return false; }

    return this.submenusUrls().some((submenuUrl: string) =>
      new RegExp(`/${this.router.url.split('/').pop()}`).test(`/${submenuUrl}`)
    );
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.submenusUrls.set(this.submenuLeftMenuItemService.getSubmenusUrls(this.menuWithSubMenu().submenu));
    this.initSubmenuSubscriptions();
  }

  public handleSubmenuClick(isSubmenuAlreadyOpen: boolean): void {
    this.closeSameLevelSubmenus();
    this.switchSubmenuState(isSubmenuAlreadyOpen);
  }

  public closeSubmenu(): void {
    this.isSubmenuOpen.set(false);
    this.collapsedSubmenuListElement()?.closeAllCollapsedSubmenus();
  }

  private openSubmenu(): void {
    this.isSubmenuOpen.set(true);
  }

  private closeSameLevelSubmenus(): void {
    this.sidebarService.closeSameLevelSubmenus(this.parentMenuId());
  }

  private initSubmenuSubscriptions(): void {
    this.initCloseAllSubmenusSubscription();
    this.initCloseSameLevelSubmenusSubscription();
  }

  private initCloseSameLevelSubmenusSubscription(): void {
    this.subscriptions.add(
      this.sidebarService.closeSameLevelSubmenus$.subscribe({
        next: (parentMenuId: string | null) => {
          const isSameLevelSubmenu = parentMenuId === this.parentMenuId();
          if (isSameLevelSubmenu) { this.closeSubmenu(); }
        }
      })
    );
  }

  private initCloseAllSubmenusSubscription(): void {
    this.subscriptions.add(
      this.sidebarService.closeAllSubmenus$.subscribe({
        next: () => this.closeSubmenu()
      })
    );
  }

  private switchSubmenuState(isSubmenuAlreadyOpenOpen: boolean): void {
    if (isSubmenuAlreadyOpenOpen) {
      this.closeSubmenu();
      return;
    }

    this.openSubmenu();
  }
}
